import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface OrielMarkProps {
    className?: string
}

const OrielMark: FC<OrielMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            aria-hidden='true'
            className={cn('size-7', className)}
        >
            <path
                d='M8 28V14a8 8 0 0 1 16 0v14'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
            />
            <path
                d='M16 6.5V28M8 18h16'
                stroke='currentColor'
                strokeWidth='1.3'
                strokeLinecap='round'
                opacity='0.5'
            />
            <circle cx='16' cy='13' r='1.9' className='fill-ember' />
        </svg>
    )
}

export default OrielMark
